import { QuestionType } from './types'

export const questions: QuestionType = {
  // stage1
  1: [
    `我要如何知道不同顏色的箭頭旋鈕要順時針轉幾格呢？`,
    `請直接告訴我七個箭頭旋鈕，各會轉到哪一個英文字母？`,
  ],
  // stage2
  2: [
    `要如何將太空人的特徵由左至右連線呢？`,
    `我知道如何將結界連線了，然後呢？`,
  ],
  // stage3
  3: [
    `我要怎麼知道這六個幾何圖形分別代表數字1~6的哪一個呢？`,
    `請直接告訴我六個算式要如何解開答案。`,
  ],
  // stage4
  4: [
    `我要如何知道三棵正確顏色的仙人掌？`,
    `要如何去除冷漠的詛咒呢？`,
  ],
  // stage5
  5: [
    `在哪裡可以找到小丑魚後方及海星前方的生物呢？`,
    `我知道小丑魚後方及海星前方的生物是什麼了，然後呢？`,
  ],
  // stage6
  6: [
    `幾週年和幾月幾號分別是什麼時候呢？`,
    `要怎麼將重要數字配對到網頁上的氣球呢？`,
  ],
}
